<script setup>
import { computed } from "vue";
import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from "radix-vue";
const props = defineProps({
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  step: {
    type: Number,
    default: 1
  },
  labelMin: {
    type: String,
    default: ""
  },
  labelMax: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: false
  }
});
defineEmits(["change"]);
const values = defineModel({ type: Array, ...{
  required: true
} });
const leftLabelClass = computed(() => {
  if (props.disabled) {
    return "text-gray-disabled";
  }
  return values.value.length > 1 ? "text-gray-l-800" : "text-form-input-content-label-idle";
});
</script>

<template>
    <div class="flex flex-col px-4 w-full h-[64px] pt-1.5 pb-2 gap-3">
        <div
            class="w-full flex items-center justify-between text-[15px] font-normal leading-[18px]"
        >
            <span :class="leftLabelClass">{{ labelMin }}</span>
            <span :class="disabled ? 'text-gray-disabled' : 'text-gray-l-800'">
                {{ labelMax }}
            </span>
        </div>

        <SliderRoot
            v-model="values"
            class="relative flex items-center select-none touch-none w-full h-5 px-3"
            :min
            :max
            :step
            :disabled
            @valueCommit="$emit('change')"
        >
            <SliderTrack
                class="bg-[#E4E4E7] relative grow rounded-full h-[3px] px-3"
            >
                <SliderRange
                    :class="[disabled ? 'bg-gray-disabled' : 'bg-branding-500']"
                    class="absolute rounded-full h-full px-3"
                />
            </SliderTrack>
            <SliderThumb
                v-for="(_thumb, index) in values"
                :key="index"
                :class="[
  disabled ? 'cursor-not-allowed border-gray-disable' : 'cursor-grab border-light-blue-primary'
]"
                class="bg-white border-[3px] rounded-full shadow-lower-3 focus:outline-none size-6"
                aria-label="Slider"
            />
        </SliderRoot>
    </div>
</template>
